import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { ShippingMethod, ShippingMethodClient } from "src/app/web-api-client";

@Component({
  selector: 'app-shipping-method-creation',
  templateUrl: './shipping-method-creation.component.html',
  styleUrls: ['./shipping-method-creation.component.scss']
})
export class ShippingMethodCreationComponent implements OnInit  {

  public isLoaded = true;
  public shippingMethods: ShippingMethod[];
  public onClose = new Subject<boolean>();
   Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public client:ShippingMethodClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      name: ['', Validators.required],
      price: [0.00, Validators.required],
      isActive: [null, Validators.required]
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {

      let shippingMethod =new ShippingMethod();

      shippingMethod.idShippingMethod = 0;
      shippingMethod.name = this.Form.value.name;
      shippingMethod.price = this.Form.value.price;
      shippingMethod.isActive = this.Form.value.isActive; 

      this.client.create(shippingMethod).subscribe((result) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}

